import 'core-js/fn/array/from';

import './modules/share';
import './modules/heroSlider';
import './modules/cardSlider';
import './modules/projectCategorySelector';
import './modules/slideshow';
import './modules/leadershipTabs';
import './modules/serviceModel';
import './modules/navDropdowns';
import './modules/navbar';
import './modules/navbarDropdowns';
import './modules/gallery';
import './modules/fixedHeader';

import '../scss/global.scss';



// WEBPACK FOOTER //
// ./resources/assets/js/main.js